import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { config, initialState } from "./config";

class ControlPointsSettings extends PanelTemplate {
    renderBody = () => {
        const { editable, config } = this.props;
        const {
            checkVisitingTime,
            checkLatenessTime,
            planDailyMileage,
            customPointTypeIds,
            maxMileageAfterCustomPoint,
        } = config;
        return (
            <>
                {this.renderField({ ...checkVisitingTime, disabled: !editable })}
                {this.renderField({ ...checkLatenessTime, disabled: !editable })}
                {this.renderField({ ...planDailyMileage, disabled: !editable })}
                {this.renderSelect({ ...customPointTypeIds, disabled: !editable })}
                {this.renderField({ ...maxMileageAfterCustomPoint, disabled: !editable })}
            </>
        );
    };

    render() {
        const cname = cn("card card-body mb-3", {
            "border-danger book-form__body--invalid": !this.state.isValid,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Настройки контрольных точек заявок для водителя</h5>
                    </div>
                    <div className="col-sm-8">
                        {this.renderBody()}
                        {this.renderButton()}
                    </div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <ControlPointsSettings {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
